(function() {
  'use strict';

  // meta information for each province
  angular.module(moduleConfig.applicationModuleName).constant('provinceMeta', {
    ab: {
      services: ['support', 'rewards'],
      ageOfMajority: 18,
      drivesLicense: '(\\d{6}\\-\\d{3})',
      language: 'en'
    },
    bc: {
      services: ['support', 'rewards'],
      ageOfMajority: 18,
      drivesLicense: '(\\d{7})',
      language: 'en'
    },
    mb: {
      services: ['support', 'rewards'],
      ageOfMajority: 18,
      drivesLicense: '([a-zA-Z]{2}\\-[a-zA-Z]{2}\\-[a-zA-Z]{2}\\-[a-zA-Z]{1}\\d{3}[a-zA-Z]{2})',
      language: 'en'
    },
    nb: {
      services: ['support', 'rewards'],
      ageOfMajority: 18,
      drivesLicense: '(\\d{7})',
      language: 'en'
    },
    nl: {
      services: ['support', 'rewards'],
      ageOfMajority: 18,
      drivesLicense: '([a-zA-Z]{1}\\d{9})',
      language: 'en'
    },
    ns: {
      services: ['support', 'rewards'],
      ageOfMajority: 18,
      drivesLicense: '([a-zA-Z]{5}\\d{9})',
      language: 'en'
    },
    on: {
      services: ['internet', 'support', 'rewards', 'btsPromotion'],
      ageOfMajority: 18,
      drivesLicense: '([a-zA-Z]{1}\\d{4}\\-\\d{5}\\-\\d{5})',
      language: 'en'
    },
    pe: {
      services: ['support', 'rewards'],
      ageOfMajority: 18,
      drivesLicense: '(\\d{1,6})',
      language: 'en'
    },
    qc: {
      services: ['support', 'rewards'],
      ageOfMajority: 18,
      drivesLicense: '([a-zA-Z]{1}\\d{4}\\-\\d{6}\\-\\d{2})',
      language: 'fr'
    },
    sk: {
      services: ['support', 'rewards'],
      ageOfMajority: 18,
      drivesLicense: '(\\d{8})',
      language: 'en'
    }
  });

  // cp key
  angular.module('eclipseApp.core').constant('PCA_KEY', 'FG35-MM76-KP82-DJ54');

  angular.module('eclipseApp.core').constant(
    'env',
    (function() {
      // polyfill for IE
      if (!window.location.origin) {
        window.location.origin =
          window.location.protocol +
          '//' +
          window.location.hostname +
          (window.location.port ? ':' + window.location.port : '');
      }

      var environment = {
        name: 'prod',
        apiBaseUrl: window.location.origin + window.location.pathname,
        cmsContentURL: window.location.origin + '/html-fido/cms/content/ute/fido/views/',
        apiBasePath: 'api/selfserve',
        fidoHomePageUrl: window.location.origin,
        idleTimeInSeconds: 1200,
        timeoutTimeInSeconds: 5,
        sessionTimeoutEnabled: true,
        salesForceUrl: 'https://rogersprod.secure.force.com/',
        enForumPage: 'http://fido.ly/1Y32zfY',
        frForumPage: 'http://fido.ly/1NVUdHr',
        enStoreLocator: 'https://www.fido.ca/consumer/storelocator',
        frStoreLocator: 'https://www.fido.ca/consumer/storelocator?setLanguage=fr',
        enWebmailLink: 'http://webmail.fido.page.ca/login.php',
        frWebmailLink: 'http://webmail.fido.page.ca/login.php?new_lang=fr_FR',
        enWebsmsLink: 'https://websms.fido.page.ca/2way/',
        frWebsmsLink: 'https://websms.fido.page.ca/bidirectionnel/?setLanguage=fr_CA',
        enVoiceMessagingFAQLink: 'https://www.fido.ca/consumer/content/postpaid-voice-messaging',
        frVoiceMessagingFAQLink: 'https://www.fido.ca/consumer/content/postpaid-voice-messaging?setLanguage=fr',
        enUpgradePhoneLink: 'http://www.fido.ca/web/content/phonewarranty/how_to_upgrade_phone',
        frUpgradePhoneLink: 'http://www.fido.ca/consumer/content/upgrade-phone?setLanguage=fr',
        enBringYourOwnPhoneLink: 'http://www.fido.ca/consumer/mobile-plans#bring-your-own-phone',
        frBringYourOwnPhoneLink: 'http://www.fido.ca/consumer/mobile-plans?setLanguage=fr',
        enFidoRoam: 'http://www.fido.ca/fidoroam',
        frFidoRoam: 'http://www.fido.ca/fidonomade',
        enFidoVice: 'http://www.fido.ca/consumer/mobile/viceland',
        frFidoVice: 'http://www.fido.ca/consumer/mobile/viceland?setLanguage=fr',
        enFidoAccessory: '/web/page/portal/Fido/Accessories',
        frFidoAccessory: '/web/page/portal/Fido/Accessories?setLanguage=fr',
        enDataByteLink: 'https://www.fido.ca/databytes',
        frDataByteLink: 'https://www.fido.ca/momentsExtras',
        genesisApiURL: '/pages/web/genesis/api/',
        msapis: {
          base: 'https://mservices.rogers.com/'
        },
        i18nUrlPrefix: 'cms/ute/fido/resource/',
        agentFeedbackSSP: 'https://rogers.qualtrics.com/jfe/form/SV_2sIfm3dWmc6lGhn',
        enFidoXtraLink:
          'https://www.fido.ca/consumer/mobile/get-new-perks-and-deals-every-thursday-with-fido-xtra?setLanguage=en',
        frFidoXtraLink:
          'https://www.fido.ca/consumer/mobile/get-new-perks-and-deals-every-thursday-with-fido-xtra?setLanguage=fr',
        prepaid: {
          repairServiceVendor: {
            endpoint: 'https://onlineportal-ca.brightstar.com/fido/login'
          }
        },
        bfaURLs: {
          ppc: {
            atgInit: '/bfa-api/v1/buy/cart/login',
            saveState: '/bfa-api/v1/spa/state',
            eligibility: '/bfa-api/v1/ppc/priceplans/eligibility',
            ppcPageURL: '/ppc/#/choose-plan',
            // BRT access control
            permissions: '/api/selfserve/v1/permissions'
          },
          hup: {
            atgInit: '/bfa-api/v1/buy/cart/login',
            saveState: '/bfa-api/v1/hup/spa/saveState',
            eligibility: '/bfa-api/v1/checkHupEligibility',
            hupPageUrl: '/hup/#/choose-phone',
            // BRT access control
            permissions: '/api/selfserve/v1/permissions'
          },
          aal: {
            aalPageUrl: '/add-a-line/phone-plans',
            aalTermPageUrl: '/phones/?flowType=aal',
            checkCTNForBan: '/bfa-api/v2/checkCTNForBan'
          }
        },
        spotifyViceFidoHub: 'http://www.fidohub.ca/portal/authenticate',
        semafoneParameters: {
          // en:'Credit Card Number',
          // fr:'Num&#233;ro de carte de cr&#233;dit',
          cybersource: {
            en: '',
            fr: '',
            semafoneUrl: 'https://hts.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragmentV3.html',
            semafoneMode: 'DISABLED',
            gatewayId: 'CYBERSOURCE',
            methodId: 'TOKENISE',
            transactionReference: '1234567890',
            ppUserId: 'fido.ca',
            ppPassword:
              'MIIBlzCCAQCgAwIBAgIEVUzNHjANBgkqhkiG9w0BAQUFADAOMQwwCgYDVQQDDANUREUwHhcNMTUwNTA4MTQ1MDA2WhcNMjUwNTA1MTQ1MDA2WjASMRAwDgYDVQQDDAdmaWRvLmNhMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCcm8wt6iochVJ68zzP6dlVWXiz3eCN3SonASDiZXulLL3aIfMuDrpSJBOC4omjTF%2FFJsahE3C%2BF6N98BXTnbI32IcNAmhpeS7qA%2F0r12aDy8Y95zRhitOM7SDZ6c3h9p9kPjM7lzJLE2o93YK7RycFu8aW09%2FApRNZHYCxswWJ7QIDAQABMA0GCSqGSIb3DQEBBQUAA4GBALdKAuIYqfyIdarsXE05R%2Bpfa3c5fFI%2Ffx2kPREIMm50gSLQWrokg8HOQAzHfM5lXWZopVl4dVrqtxGugS91kHyfexww3LUVU0bfdEj9giof%2By4gBlTlUabm%2BaXCbA5cXkVRC5qeICmw3d0GufL6dPzzyfc3FwXeOoY0ttFNKCgy',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '541',
            principle: 'fidop',
            licenseCode: 'aV2FcqS0Jv',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://hts.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragmentV3.html',
            //pciTokeniseURL:'https://rtlt.rogers.com/semafone/service/integration/rogers/retail/tokenise'
            pciTokeniseURL: '/cardreader'
          },
          moneris: {
            en: '',
            fr: '',
            semafoneUrl: 'https://hts.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragmentV3.html',
            semafoneMode: 'DISABLED',
            gatewayId: 'MONERIS',
            methodId: 'TOKENISE',
            transactionReference: '1234567890',
            ppUserId: 'vaas000191',
            ppPassword: '4zrrJiQSCeG3TI9KeheX',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '541',
            principle: 'fidop',
            licenseCode: 'aV2FcqS0Jv',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://hts.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragmentV3.html',
            //pciTokeniseURL:'https://rtlt.rogers.com/semafone/service/integration/rogers/retail/tokenise'
            pciTokeniseURL: '/cardreader'
          }
        },
        storeLocatorConfig: {
          keyId: 'AIzaSyCdffW3oM5B0ltY0E2Y3z5iOoLsZBQ3bEM',
          tableId: '16372890481429813403-12921502713420913455' // Fido table id for google map
          //tableId: '16372890481429813403-09757940799309423091',	// Rogers table id for google map
        },
        recaptcha: '6Lc3wXQUAAAAAIyCPwAVQ8j-XuSOQROIu11ZASFA',
        prepaidLinkAccountRecaptchaSiteKeyV2: '6LfWvL4UAAAAAAZow_cHnCJUP9-syo1du5kG6t8V'
      };

      // janrain settings - Check for settings, create if it doesn't exist
      // if (typeof window.janrain !== 'object') window.janrain = {};
      // if (typeof window.janrain.settings !== 'object') {
      //   window.janrain.settings = {
      //     packages: ['login','capture'],
      //     language: window.__userPref.language == 'fr' ? 'fr' : 'en-US',
      //     tokenUrl: 'https://localhost/',
      //     tokenAction: 'event',look
      //     borderColor: '#ffffff',
      //     fontFamily: 'Helvetica, Lucida Grande, Verdana, sans-serif',
      //     width: 300,
      //     actionText: ' ',
      //     appUrl: 'https://fido-dev.rpxnow.com',
      //     providers : ['facebook'],
      //     forceReauth: false,
      //     format: 'two column',
      //     type:'embed',
      //     showAttribution:false,
      //     providersPerPage:'4',
      //     translate:{
      //     	SIGN_IN_AS:window.__userPref.language == 'fr' ? 'ID de session :{name}' : "Log in as {name}"
      //     },
      //     capture: {
      //       captureServer: 'https://rogers-fido.janraincapture.com',
      //       appId: 'xjwuuvc75rs76j73wqfq2zsh85',
      //       clientId: 'bfkecrvys7sprse8kc4wtwugr2bj9hmp',
      //       redirectUri: window.location.origin+window.location.pathname+'#/',
      //       flowName: 'fido',
      //       flowVersion: '20181203202136607565',
      //       screenToRender : 'returnTraditional',
      //       registerFlow: 'traditionalRegistration',
      //       setProfileCookie: true,
      //       keepProfileCookieAfterLogout: true,
      //       modalCloseHtml: 'X',
      //       noModalBorderInlineCss: true,
      //       responseType: 'token',
      //       returnExperienceUserData: ['displayName','userID','uuid'],
      //       federate: true,
      //       ssoFileUrl : 'https://cdn.janrainsso.com/sso.js',
      //       federateServer: 'https://rogers-fido.janrainsso.com',
      //       federateXdReceiver: window.location.origin +window.location.pathname+ 'validate/janrain/xfederate.html',
      //       federateLogoutUri: window.location.origin + window.location.pathname+ 'validate/janrain/blank.html',
      //       federateLogoutCallback: function() {},
      //       federateEnableSafari: false,
      //     },
      //     ute: {
      //       widgetpath: document.location.protocol === 'https:' ? 'https://rpxnow.com/load/fido-dev' : 'http://widget-cdn.rpxnow.com/load/fido-dev',
      //     }
      //   };
      // }

      // janrain starter
      // if (document.addEventListener) {
      //   document.addEventListener("DOMContentLoaded", function(){ window.janrain.ready = true; }, false);
      // } else {
      //   window.attachEvent('onload', function(){ window.janrain.ready = true; });
      // }

      // $('<script src="' + window.janrain.settings.ute.widgetpath + '" type="text/javascript" id="janrainAuthWidget"></script>').appendTo('body');

      return environment;
    })()
  );
})();
